<template>
  <div class="excel-import">
    <input
      type="file"
      ref="fileInput"
      class="hidden"
      accept=".txt"
      @change="handleClick"
      :disabled="disabled"
    />
    <div
      @click="$refs.fileInput.click()"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl"
    >
      <feather-icon
        icon="UploadCloudIcon"
        svgClasses="h-16 w-16 stroke-current text-grey"
        class="block"
      />
      <span>Drop Text File or </span>
      <span
        class="font-medium text-primary"
        @click.stop="$refs.fileInput.click()"
        >Browse</span
      >
      <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onSuccess: {
      type: Function,
      required: true,
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      importData: {
        headers: null,
        results: null,
        meta: null,
        json:null
      }
    }
  },
  methods: {
    generateData ({ headers, results, meta, json}) {
      this.importData.headers = headers
      this.importData.results = results
      this.importData.meta = meta
      this.importData.json = json
      if (this.onSuccess) this.onSuccess(this.importData)
    },
    getData (data) {
      let lines
      let max = 0

      //Separo linea por linea
      lines = data.split('\n')

      //Saco los nombres de las columnas
      const columns = []
      const headers = []
      lines.map(function (v, k) {
        const column = v.split('|')
        column.pop()
        if (column.length > 0) {
          columns.push(column)
          headers.push(column[0])
        }

      })

      //REVISO CUANTOS REGISTROS HAY SEGUN EL NUMERO DE PARTE Y WAREHOUSE
      for (let i = 0; i < columns.length; i++) {
        if (i == 3 || i == 10) {
          if (max < columns[i].length) {
            max = columns[i].length
          }
        }
      }

      //COMPRUEBO QUE TODOS TENGAN LA MISMA LONGITUD
      for (let i = 0; i < columns.length; i++) {
        for (let x = 0; x < max; x++) {
          if (i < 3 && x > 1) {
            columns[i][x] = columns[i][1]
          }
          if (!columns[i][x]) {
            columns[i][x] = ''
          }
        }
      }

      let results = []
      //INICIAR DE 1 para evitar las cabeceras
      for (let j = 1; j < columns[0].length; j++) {
        results[j] = []
        for (let k = 0; k < columns.length; k++) {
          results[j].push(columns[k][j])
        }
      }

      results = results.filter((_, i) => i in results)

      return { headers, results }
    },
    handleClick (e) {
      const files = e.target.files
      if (this.validateFile(files)) this.uploadFile(files[0])

    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (this.validateFile(files)) this.uploadFile(files[0])

    },
    isTextFile (file) {
      return /\.(txt)$/.test(file.name.toLowerCase())
    },
    validateFile (files) {
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isTextFile(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .txt suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },
    readerData (rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsText(rawFile)
        reader.onload = (e) => {
          const data = e.target.result
          const { headers, results } = this.getData(data)
          const meta = { fileName: rawFile.name }
          const json = this.createJson(headers, results)
          this.generateData({ headers, results, meta, json})
          resolve()
        }
        //reader.readAsArrayBuffer(rawFile)
      })
    },
    uploadFile (file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    },
    arrMerge (k, v) {
      const obj = {}
      for (let i = 0; i < k.length; i++) {
        obj[k[i]] = v[i]
      }
      return obj
    },
    createJson (headers, results) {
      const json = []
      //let arr = []
      results.forEach(row => {
        const obj = this.arrMerge(headers, row)
        json.push(obj)
      })

      return JSON.parse(JSON.stringify(json))
    }
  }
}
</script>
